<template>
  <dash-page-new
      :title="$t('Settings')"
  >
  <h1>Mailer Settings will be here</h1>
  </dash-page-new>
</template>

<script>
export default {
  name: "mailerLetters"
}
</script>

<style scoped>

</style>